module.exports = __webpack_public_path__ + "public/images/lines.png";